export class UserEntity {

    public static fromDto(dto: any): UserEntity {
        if (!dto) {
            return new UserEntity();
        }
        const entity = new UserEntity();

        entity.id = dto.id;
        entity.email = dto.email;
        entity.pin = dto.pin;
        entity.nameIdentifier = dto.nameIdentifier;
        entity.termsAcceptedAt = dto.termsAcceptedAt ? new Date(dto.termsAcceptedAt) : null;
        entity.privacyAcceptedAt = dto.privacyAcceptedAt ? new Date(dto.privacyAcceptedAt) : null;
        entity.emailMarketingConsent = dto.emailMarketingConsent ?? false;
        entity.linkedProviders = dto.linkedProviders ?? [];
        entity.passkeyCount = dto.passkeyCount ?? 0;
        entity.concurrency = dto.concurrency;
        return entity;
    }

    public static fromDtoArray(dtoArray: any[]): UserEntity[] {
        const entities: UserEntity[] = [];
        if (!dtoArray) {
            return entities;
        }
        for (const dto of dtoArray) {
            const entity = UserEntity.fromDto(dto);
            entities.push(entity);
        }
        return entities;
    }

    public static toDtoArray(entityArray: UserEntity[]): any[] {
        const dtos = [];
        for (const entity of entityArray) {
            dtos.push(entity.toDto());
        }
        return dtos;
    }
    public id: string = null;

    public email: string = null;
    public nameIdentifier: string = null;
    public pin: string = null;
    public termsAcceptedAt: Date = null;
    public privacyAcceptedAt: Date = null;
    public emailMarketingConsent: boolean = false;
    public linkedProviders: string[] = [];
    public passkeyCount: number = 0;
    public concurrency: string = null;

    public toDto(): any {
        return {
            id: this.id,
            email: this.email,
            nameIdentifier: this.nameIdentifier,
            pin: this.pin,
            concurrency: this.concurrency
        };
    }
}
